const dibujarImagenEnCanvas = (canvas, source, maxWidth, maxHeight) => {
    let width = source.width;
    let height = source.height;

    if (width > height) {
        if (width > maxWidth) {
            height = Math.round((height * maxWidth) / width);
            width = maxWidth;
        }
    } else if (height > maxHeight) {
        width = Math.round((width * maxHeight) / height);
        height = maxHeight;
    }

    canvas.width = width;
    canvas.height = height;

    const ctx = canvas.getContext('2d');
    ctx.drawImage(source, 0, 0, width, height);

    return { width, height };
};

const canvasToBlob = (canvas, type, quality) => new Promise((resolve, reject) => {
    canvas.toBlob(
        (blob) => {
            if (blob) {
                resolve(blob);
            } else {
                reject(new Error('Error al redimensionar imagen'));
            }
        },
        type,
        quality
    );
});

const resizeWithImageElement = (file, maxWidth, maxHeight, quality) => new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = (e) => {
        const img = new Image();

        img.onload = async () => {
            try {
                const canvas = document.createElement('canvas');
                dibujarImagenEnCanvas(canvas, img, maxWidth, maxHeight);
                const blob = await canvasToBlob(canvas, file.type, quality);
                resolve(blob);
            } catch (error) {
                reject(error);
            }
        };

        img.onerror = () => reject(new Error('Error al cargar imagen'));
        img.src = e.target.result;
    };

    reader.onerror = () => reject(new Error('Error al leer archivo'));
    reader.readAsDataURL(file);
});

/**
 * Redimensiona una imagen para optimizar su tamaño antes de subirla.
 * Respeta la orientación EXIF cuando el navegador lo soporta.
 */
export const resizeImage = (file, maxWidth = 800, maxHeight = 800, quality = 0.8) => {
    if (typeof createImageBitmap === 'function') {
        return createImageBitmap(file, { imageOrientation: 'from-image' })
            .then(async (bitmap) => {
                try {
                    const canvas = document.createElement('canvas');
                    dibujarImagenEnCanvas(canvas, bitmap, maxWidth, maxHeight);
                    const blob = await canvasToBlob(canvas, file.type, quality);
                    return blob;
                } finally {
                    bitmap.close();
                }
            })
            .catch(() => resizeWithImageElement(file, maxWidth, maxHeight, quality));
    }

    return resizeWithImageElement(file, maxWidth, maxHeight, quality);
};
